export default "/profile/images/Amploo.png?cc00d3cefdb41d5d915bed752274080b";